
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2023
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'createDashboardTitle': 'Vytvořit panel dashboard',
	'dashboard': 'Panel dashboard',
	'dashboardTemplate': 'Šablona panelu dashboard',
	'createAV': 'Vytvořit',
	'createAvEditNameLabel': '1. Pojmenujte své zobrazení',
	'createAvSelectTemplateLabel': '2. Vyberte šablonu',
	'tabLayoutLabel': 'Šablona s kartami',
	'infographicsLayoutLabel': 'Šablona s infografikou',
	'singlePageLayoutLabel': 'Šablona s jednou stránkou',
	'customLayoutLabel': 'Vlastní šablona',
	'freeformTemplate': 'Volný formát',
	'freeformTemplateDesc': 'Vizualizace v rozvržení volného formátu se zobrazují přesně tak, jak je dimenzujete a umístíte v zobrazení, bez ohledu na velikost obrazovky. V jiných rozvrženích se velikost a pozice vizualizací přizpůsobují podle velikosti obrazovky.',
	'NoTemplate': 'Volný formát',
	'Template1': 'Prázdný objekt',
	'Template2': 'Nadpis 1 × 2',
	'Template3': '2 přes 1',
	'Template4': '4 přes 1',
	'Template5': 'Zápatí 1 × 2',
	'Template6': '3 vedle 1 přes 1',
	'Template7': '4 vedle 3 přes 1',
	'Template8': '2 přes 3 × 2',
	'Template9': '2 × 2',
	'Template10': '1 × 2 vedle 2 × 2 přes 1',
	'Template11': '3 × 1 přes 1 × 2',
	'Template12': '2 přes 1 vedle 1 × 2',
	'Template13': '1 vedle 1 × 2 vedle 1 × 4',
	'Template22': '1 přes 2 × 2',
	'Template14': '1 vedle 1',
	'Template15': '1 přes 1 vedle 1',
	'Template16': '1 vedle 1 přes 1',
	'Template17': '1 přes 1 vedle 1 přes 1',
	'Template18': '1 přes 1 vedle 1',
	'Template19': '1 přes 2 vedle 1',
	'Template20': '1 přes 2 × 1',
	'Template21': '1 přes 1 přes 2 × 1',
	'Template23': 'Prázdný objekt se zónou umístění',
	'Infographics1': 'Prázdný objekt',
	'Infographics2': '4 řádky',
	'Infographics3': '4 řádky se záhlavím',
	'Infographics4': '2 × 4',
	'Infographics5': 'Velké horní zobrazení s 2 × 2',
	'Infographics6': '2 × 4 se svislou mezerou',
	'Infographics7': '2 × 4 proložené',
	'Infographics8': 'Tenisový kurt',
	'Infographics9': '3 × 4',
	'Infographics10': '4 × 8',
	'createAvDashboardLabel': 'Rozvržení',
	'dashboard_template_save_success': 'Vaše šablona panelu dashboard byla uložena.',
	'dashboard_template_prefix': 'Šablona: "%{name}"',
	'dashboard_template_filters_removed': 'Filtry na plátně byly odebrány.',
	'createAvTabLabel': 'S kartami',
	'createAvInfographicsLabel': 'Infografika',
	'createAvSinglepageLabel': 'Jediná stránka',
	'createAvCustomLabel': 'Vlastní',
	'loadMoreLabel': 'Načíst další...',
	'backLabel': 'Přejít zpět',
	'addSourceLabel': 'Přidat zdroj',
	'pinLabel': 'Fixovat',
	'errorLoadingDataSetMetaData': 'Při čtení metadat došlo k chybě.',
	'errorLoadingDataSets': 'Při načítání seznamu datových sad došlo k chybě.',
	'errorLoadingDataSet': 'Metadata pro datovou sadu "%{datasetName}" nebyla načtena. Požádejte administrátora, aby vám poskytl další podrobností.',
	'okButton': 'OK',
	'createButton': 'Vytvořit',
	'cancelButton': 'Storno',
	'copyButton': 'Kopírovat',
	'selectTemplateLabel': 'Vybrat šablonu',
	'createBoardTitle': 'Vytvoření panelu dashboard',
	'createBoardSubtitle': 'Vybrat šablonu pro panel dashboard',
	'noSourcesSelectedLabel': 'Nejsou vybrány žádné zdroje.',
	'find_label': 'Najít',
	'noDashboardFound': 'Panel dashboard se nepodařilo načíst. Buďto již neexistuje, nebo k němu nemáte dostatečná oprávnění a nemůžete jej zobrazit.',
	'errorLabel': 'Chyba',
	'defaultName': 'Nový panel dashboard',
	'noDashboardCapability': 'Nemáte možnost spustit aplikaci panelu dashboard.',
	'noCapabilityForCreateDashboard': 'Nemáte požadovanou schopnost pro vytvoření řídicího panelu pro vybraná aktiva',
	'noCapabilityForEdit': 'Nemáte možnost upravovat tento panel dashboard',
	'noCapabilityForSave': 'Nemáte možnost ukládat tento panel dashboard',
	'noCapabilityForPaste': 'Nemáte možnost vkládat zkopírované moduly widget do tohoto pohledu.',
	'noCapabilityForPin': 'Nemáte možnost přidávat tento kód PIN',
	'noCapabilityForLaunchInExplore': 'Nemáte možnost spouštět zkopírované moduly widget v prozkoumání',
	'noDashboardPermission': 'Nemáte dostatečná oprávnění pro zobrazení tohoto panelu dashboard.',
	'sourceNotFound': 'Nelze načíst vizualizaci, protože přidružený zdroj "%{sourceName}" není k dispozici.',
	'cmDuplicateName': 'Položka s tímto názvem již existuje. Zkuste použít jiný název.',
	'cmEmptySelection': 'Panel dashboard byl odstraněn. Zkuste provést uložení jako nový panel dashboard.',
	'propTheme_v1': 'Vizuální motiv',
	'propTheme': 'Motiv',
	'legacyThemeLabel': 'Starší',
	'carbonGrey10Label': 'Motiv Carbon X světlý',
	'carbonGrey100Label': 'Motiv Carbon X temný',
	'titleTextLabel': 'Nadpis',
	'titleSmallTextLabel': 'Malý nadpis',
	'subtitleTextLabel': 'Podtitul',
	'bodyTextLabel': 'Tělo',
	'bodySmallTextLabel': 'Malé tělo',
	'captionTextLabel': 'Titulek',
	'quoteTextLabel': 'Citace',
	'quoteSmallTextLabel': 'Malá citace',
	'responsiveTextLabel': 'Automatická velikost',
	'mediaWidgetLabel': 'Médium',
	'webpageWidgetLabel': 'Webová stránka',
	'imageWidgetLabel': 'Obrázek',
	'textWidgetLabel': 'Text',
	'notebookWidgetLabel': 'Zápisník',
	'multipurposeWidgetLabel': 'Víceúčelové',
	'textPlaceHolder': 'Klepnutím upravte text',
	'titlePlaceHolder': 'Klepnutím upravte nadpis',
	'toggleEditModeLabel': 'Přepnout do úprav',
	'togglePreviewModeLabel': 'Přepnout do náhledu',
	'editDashboardCoachMarkTitle': 'Upravit panel dashboard',
	'editDashboardCoachMarkContents': 'Chcete-li tento panel dashboard upravit, klepněte na ikonu tužky.',
	'addDataCoachMarkTitle': 'Přidat data',
	'addDataDashboardCoachMarkContents': 'Pomocí myši přetáhněte data z panelu dat na panel dashboard.',
	'pageSelectWarning': 'Vyberte kartu.',
	'screenshot_label': 'Panel dashboard %{title}',
	'screenshot_label_tab': 'Karta %{tabName} panelu dashboard %{title}',
	'dataAssetPropertiesLabel': 'Vlastnosti vizualizace',
	'modelFilter': 'Filtr',
	'invertSelectionToolTip': 'Invertovat výběry filtru',
	'clearFilterValueToolTip': 'Vymazat hodnoty filtru',
	'invertFilterSelection': 'Invertovat',
	'clearTextFilterValue': 'Vymazat',
	'filterConditionLabel': 'Podmínka filtru',
	'applyFilter': 'Použijte filtr',
	'itemCountText': 'Počet vybraných položek: %{itemCount}',
	'itemExcludeCountText': 'Počet nezahrnutých položek: %{itemCount}',
	'moreMembers': 'Zobrazit další...',
	'searchHierarchyMembers': 'Najít členy s použitím hledání...',
	'propHideEmpty': 'Skrýt prázdné',
	'propColorOrder': 'Pořadí barev',
	'propElementColor': 'Barva prvku vizualizace',
	'propLineColor': 'Barva čáry',
	'propLineAndSymbolColor': 'Barva čáry a symbolu',
	'propColumnColor': 'Barva sloupce',
	'propBarColor': 'Barva pruhu',
	'propWordColor': 'Barva slova',
	'propAreaColor': 'Barva oblasti',
	'propRadialbarColor': 'Barva radiálního pruhu',
	'propColorPalettes': 'Palety barev',
	'propDashboardColorPalette': 'Aktuální paleta panelu dashboard',
	'propNewDashboardPaletteLabel': 'Vytvořit vlastní paletu panelu dashboard',
	'propDashboardChangePaletteLink': 'Změnit paletu panelu dashboard',
	'propHideLeafNode': 'Skrýt popisky listů',
	'propOpacity_v1': 'Opacita modulu widget',
	'propOpacity': 'Opacita modulu widget (%)',
	'propOpacityDescription': 'Nastaví objekt jako více průhledný, nebo jako méně průhledný. Zadejte hodnotu v rozsahu 0 až 100',
	'addATab': 'Přidat novou kartu',
	'propFredIsRed': 'Konzistence barev',
	'areaChartCaption': 'Plošný',
	'areaChartDataSlot_categoriesLabel': 'Popisek osy',
	'areaChartDataSlot_valuesLabel': 'Hodnota',
	'areaChartProp_colorPaletteLabel': 'Palety barev',
	'areaChartProp_lineColorLabel': 'Barva oblasti',
	'areaChartProp_interpolationLabel': 'Plynulý čárový',
	'areaChartProp_interpolationDescription': 'Čáry spojující datové body jsou zakřivené.',
	'areaChartProp_hideGridLinesLabel': 'Skrýt čáry mřížky',
	'areaChartProp_hideGridLinesDescription': 'Skrýt čáry mřížky',
	'areaChartProp_hideAxisTitleLabelsLabel': 'Skrýt popisky s nadpisy os',
	'areaChartProp_hideAxisTitleLabelsDescription': 'Skrýt nadpisy pro osy.',
	'areaChartProp_maintainAxisScalesLabel': 'Zachovat měřítka osy',
	'areaChartProp_maintainAxisScalesDescription': 'Vždy na osách zobrazovat minimální a maximální hodnoty.',
	'areaChartProp_suppressZerosLabel': 'Skrýt prázdné',
	'areaChartProp_suppressZerosDescription': 'Skrýt kategorie bez přidružených hodnot.',
	'barChartCaption': 'Pruhový',
	'barChartDataSlot_categoriesLabel': 'Popisek osy',
	'barChartDataSlot_valuesLabel': 'Hodnota',
	'barChartProp_colorPaletteLabel': 'Palety barev',
	'barChartProp_elementColorLabel': 'Barva pruhu',
	'barChartProp_hideGridLinesLabel': 'Skrýt čáry mřížky',
	'barChartProp_hideGridLinesDescription': 'Skrýt čáry mřížky',
	'barChartProp_hideAxisTitleLabelsLabel': 'Skrýt popisky s nadpisy os',
	'barChartProp_hideAxisTitleLabelsDescription': 'Skrýt nadpisy pro osy.',
	'barChartProp_maintainAxisScalesLabel': 'Zachovat měřítka osy',
	'barChartProp_maintainAxisScalesDescription': 'Vždy na osách zobrazovat minimální a maximální hodnoty.',
	'barChartProp_suppressZerosLabel': 'Skrýt prázdné',
	'barChartProp_suppressZerosDescription': 'Skrýt kategorie bez přidružených hodnot.',
	'columnChartCaption': 'Sloupec',
	'columnChartDataSlot_categoriesLabel': 'Popisek osy',
	'columnChartDataSlot_valuesLabel': 'Hodnota',
	'columnChartProp_colorPaletteLabel': 'Palety barev',
	'columnChartProp_elementColorLabel': 'Barva sloupce',
	'columnChartProp_hideGridLinesLabel': 'Skrýt čáry mřížky',
	'columnChartProp_hideGridLinesDescription': 'Skrýt čáry mřížky',
	'columnChartProp_hideAxisTitleLabelsLabel': 'Skrýt popisky s nadpisy os',
	'columnChartProp_hideAxisTitleLabelsDescription': 'Skrýt nadpisy pro osy.',
	'columnChartProp_maintainAxisScalesLabel': 'Zachovat měřítka osy',
	'columnChartProp_maintainAxisScalesDescription': 'Vždy na osách zobrazovat minimální a maximální hodnoty.',
	'columnChartProp_suppressZerosLabel': 'Skrýt prázdné',
	'columnChartProp_suppressZerosDescription': 'Skrýt kategorie bez přidružených hodnot.',
	'bubbleChartCaption': 'Bublinový',
	'bubbleChartDataSlot_xAxisLabel': 'Vodorovná osa',
	'bubbleChartDataSlot_yAxisLabel': 'Svislá osa',
	'bubbleChartDataSlot_sizeLabel': 'Velikost podle:',
	'bubbleChartDataSlot_colorLabel': 'Barva podle:',
	'bubbleChartProp_colorPaletteLabel': 'Palety barev',
	'bubbleChartProp_hideGridLinesLabel': 'Skrýt čáry mřížky',
	'bubbleChartProp_hideGridLinesDescription': 'Skrýt čáry mřížky',
	'bubbleChartProp_hideAxisTitleLabelsLabel': 'Skrýt popisky s nadpisy os',
	'bubbleChartProp_hideAxisTitleLabelsDescription': 'Skrýt nadpisy pro osy.',
	'bubbleChartProp_maintainAxisScalesLabel': 'Zachovat měřítka osy',
	'bubbleChartProp_maintainAxisScalesDescription': 'Vždy na osách zobrazovat minimální a maximální hodnoty.',
	'bubbleChartProp_hideLegendLabel': 'Skrýt legendu',
	'bubbleChartProp_hideLegendDescription': 'Skrýt legendu.',
	'bubbleChartProp_legendPositionLabel': 'Poloha legendy',
	'lineChartCaption': 'Čára',
	'lineChartDataSlot_categoriesLabel': 'Popisek osy',
	'lineChartDataSlot_valuesLabel': 'Hodnota',
	'lineChartProp_colorPaletteLabel': 'Palety barev',
	'lineChartProp_lineColorLabel': 'Barva čáry a symbolu',
	'lineChartProp_symbolShapeLabel': 'Tvar symbolu',
	'lineChartProp_hideSymbolsLabel': 'Skrýt symboly',
	'lineChartProp_hideSymbolsDescription': 'Skrýt symboly',
	'lineChartProp_hideDataLinesLabel': 'Skrýt čáry',
	'lineChartProp_hideDataLinesDescription': 'Skrýt čáry',
	'lineChartProp_interpolationLabel': 'Plynulý čárový',
	'lineChartProp_interpolationDescription': 'Čáry spojující datové body jsou zakřivené.',
	'lineChartProp_hideGridLinesLabel': 'Skrýt čáry mřížky',
	'lineChartProp_hideGridLinesDescription': 'Skrýt čáry mřížky',
	'lineChartProp_hideAxisTitleLabelsLabel': 'Skrýt popisky s nadpisy os',
	'lineChartProp_hideAxisTitleLabelsDescription': 'Skrýt nadpisy pro osy.',
	'lineChartProp_maintainAxisScalesLabel': 'Zachovat měřítka osy',
	'lineChartProp_maintainAxisScalesDescription': 'Vždy na osách zobrazovat minimální a maximální hodnoty.',
	'lineChartProp_suppressZerosLabel': 'Skrýt prázdné',
	'lineChartProp_suppressZerosDescription': 'Skrýt kategorie bez přidružených hodnot.',
	'packedBubbleChart1CatCaption': 'Sbalený bublinový',
	'packedBubbleChart1CatDataSlot_categoriesLabel': 'Kategorie',
	'packedBubbleChart1CatDataSlot_sizeLabel': 'Velikost podle:',
	'packedBubbleChart1CatProp_colorPaletteLabel': 'Palety barev',
	'packedBubbleChart1CatProp_elementColorLabel': 'Barva bublin',
	'packedBubbleChart1CatProp_hideLabelLabel': 'Skrýt popisek',
	'packedBubbleChart1CatProp_hideValueLabel': 'Skrýt hodnotu',
	'packedBubbleChart1CatProp_maintainAxisScalesLabel': 'Zachovat měřítka osy',
	'packedBubbleChart1CatProp_maintainAxisScalesDescription': 'Vždy na osách zobrazovat minimální a maximální hodnoty.',
	'packedBubbleChart1CatProp_suppressZerosLabel': 'Skrýt prázdné',
	'packedBubbleChart1CatProp_suppressZerosDescription': 'Skrýt kategorie bez přidružených hodnot.',
	'heatChartCaption': 'Teplotní',
	'heatChartDataSlot_valuesLabel': 'Teplota podle:',
	'heatChartDataSlot_xAxisLabel': 'Vodorovná osa',
	'heatChartDataSlot_yAxisLabel': 'Svislá osa',
	'heatChartProp_colorPaletteLabel': 'Palety barev',
	'heatChartProp_heatScalePaletteLabel': 'Pořadí barev',
	'heatChartProp_hideAxisTitleLabelsLabel': 'Skrýt popisky s nadpisy os',
	'heatChartProp_hideAxisTitleLabelsDescription': 'Skrýt nadpisy pro osy.',
	'heatChartProp_maintainAxisScalesLabel': 'Zachovat měřítka osy',
	'heatChartProp_maintainAxisScalesDescription': 'Vždy na osách zobrazovat minimální a maximální hodnoty.',
	'heatChartProp_suppressZerosLabel': 'Skrýt prázdné',
	'heatChartProp_suppressZerosDescription': 'Skrýt kategorie bez přidružených hodnot.',
	'heatChartProp_hideLegendLabel': 'Skrýt legendu',
	'heatChartProp_hideLegendDescription': 'Skrýt legendu.',
	'heatChartProp_legendPositionLabel': 'Poloha legendy',
	'pieChartCaption': 'Výsečový',
	'pieChartDataSlot_categoriesLabel': 'Kategorie',
	'pieChartDataSlot_valuesLabel': 'Hodnota',
	'pieChartProp_colorPaletteLabel': 'Palety barev',
	'pieChartProp_hideRadialValueLabel': 'Skrýt hodnotu',
	'pieChartProp_pieAsDonutLabel': 'Zobrazit jako prstencový graf',
	'pieChartProp_pieAsDonutDescription': 'Zobrazit jako prstencový graf',
	'pieChartProp_suppressZerosLabel': 'Skrýt prázdné',
	'pieChartProp_suppressZerosDescription': 'Skrýt kategorie bez přidružených hodnot.',
	'pieChartProp_hideLegendLabel': 'Skrýt legendu',
	'pieChartProp_hideLegendDescription': 'Skrýt legendu.',
	'pieChartProp_legendPositionLabel': 'Poloha legendy',
	'map1measureCaption': 'Mapa',
	'map1measureDataSlot_categoriesLabel': 'Oblasti',
	'map1measureDataSlot_valuesLabel': 'Teplota oblasti',
	'map1measureProp_colorPaletteLabel': 'Palety barev',
	'map1measureProp_heatScalePaletteLabel': 'Pořadí barev',
	'map1measureProp_maintainAxisScalesLabel': 'Zachovat měřítka osy',
	'map1measureProp_maintainAxisScalesDescription': 'Vždy na osách zobrazovat minimální a maximální hodnoty.',
	'map1measureProp_suppressZerosLabel': 'Skrýt prázdné',
	'map1measureProp_suppressZerosDescription': 'Skrýt kategorie bez přidružených hodnot.',
	'map1measureProp_hideLegendLabel': 'Skrýt legendu',
	'map1measureProp_hideLegendDescription': 'Skrýt legendu.',
	'map1measureProp_legendPositionLabel': 'Poloha legendy',
	'radialChartCaption': 'Radiální',
	'radialChartDataSlot_categoriesLabel': 'Kategorie',
	'radialChartDataSlot_valuesLabel': 'Hodnota',
	'radialChartProp_colorPaletteLabel': 'Palety barev',
	'radialChartProp_elementColorLabel': 'Barva radiálního pruhu',
	'radialChartProp_hideRadialTitleLabel': 'Skrýt nadpis',
	'radialChartProp_hideRadialValueLabel': 'Skrýt hodnotu',
	'radialChartProp_maintainAxisScalesLabel': 'Zachovat měřítka osy',
	'radialChartProp_maintainAxisScalesDescription': 'Vždy na osách zobrazovat minimální a maximální hodnoty.',
	'radialChartProp_suppressZerosLabel': 'Skrýt prázdné',
	'radialChartProp_suppressZerosDescription': 'Skrýt kategorie bez přidružených hodnot.',
	'pointChart1catCaption': 'Bod',
	'pointChart1catDataSlot_valuesLabel': 'Hodnota',
	'pointChart1catDataSlot_categoriesLabel': 'Popisek osy',
	'pointChart1catProp_colorPaletteLabel': 'Palety barev',
	'pointChart1catProp_elementColorLabel': 'Barva tvaru',
	'pointChart1catProp_symbolShapeLabel': 'Tvar symbolu',
	'pointChart1catProp_symbolFillLabel': 'Vyplnit tvar',
	'pointChart1catProp_symbolFillDescription': 'Zobrazovat barvu výplně pro symboly.',
	'pointChart1catProp_hideGridLinesLabel': 'Skrýt čáry mřížky',
	'pointChart1catProp_hideGridLinesDescription': 'Skrýt čáry mřížky',
	'pointChart1catProp_hideAxisTitleLabelsLabel': 'Skrýt popisky s nadpisy os',
	'pointChart1catProp_hideAxisTitleLabelsDescription': 'Skrýt nadpisy pro osy.',
	'pointChart1catProp_maintainAxisScalesLabel': 'Zachovat měřítka osy',
	'pointChart1catProp_maintainAxisScalesDescription': 'Vždy na osách zobrazovat minimální a maximální hodnoty.',
	'pointChart1catProp_suppressZerosLabel': 'Skrýt prázdné',
	'pointChart1catProp_suppressZerosDescription': 'Skrýt kategorie bez přidružených hodnot.',
	'scatterPlotChartNoCatCaption': 'Bodový výkres',
	'scatterPlotChartNoCatDataSlot_xAxisLabel': 'Vodorovná osa',
	'scatterPlotChartNoCatDataSlot_yAxisLabel': 'Svislá osa',
	'scatterPlotChartNoCatProp_colorPaletteLabel': 'Palety barev',
	'scatterPlotChartNoCatProp_elementColorLabel': 'Barva prvku',
	'scatterPlotChartNoCatProp_symbolShapeLabel': 'Tvar symbolu',
	'scatterPlotChartNoCatProp_symbolFillLabel': 'Vyplnit tvar',
	'scatterPlotChartNoCatProp_symbolFillDescription': 'Zobrazovat barvu výplně pro symboly.',
	'scatterPlotChartNoCatProp_hideGridLinesLabel': 'Skrýt čáry mřížky',
	'scatterPlotChartNoCatProp_hideGridLinesDescription': 'Skrýt čáry mřížky',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsLabel': 'Skrýt popisky s nadpisy os',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsDescription': 'Skrýt nadpisy pro osy.',
	'radialBarChartCaption': 'Radiální pruhový',
	'radialBarChartDataSlot_categoriesLabel': 'Kategorie',
	'radialBarChartDataSlot_valuesLabel': 'Hodnota',
	'radialBarChartProp_colorPaletteLabel': 'Palety barev',
	'radialBarChartProp_elementColorLabel': 'Barva radiálního pruhu',
	'radialBarChartProp_hideRadialTitleLabel': 'Skrýt nadpis',
	'radialBarChartProp_maintainAxisScalesLabel': 'Zachovat měřítka osy',
	'radialBarChartProp_maintainAxisScalesDescription': 'Vždy na osách zobrazovat minimální a maximální hodnoty.',
	'radialBarChartProp_suppressZerosLabel': 'Skrýt prázdné',
	'radialBarChartProp_suppressZerosDescription': 'Skrýt kategorie bez přidružených hodnot.',
	'lineColumnComboChartCaption': 'Čára a sloupec',
	'lineColumnComboChartDataSlot_categoryLabel': 'Popisek osy',
	'lineColumnComboChartDataSlot_lineValueLabel': 'Čárová hodnota',
	'lineColumnComboChartDataSlot_columnValueLabel': 'Sloupcová hodnota',
	'lineColumnComboChartProp_colorPaletteLabel': 'Palety barev',
	'lineColumnComboChartProp_elementColorLabel': 'Barva sloupce',
	'lineColumnComboChartProp_lineColorLabel': 'Barva čáry a symbolu',
	'lineColumnComboChartProp_symbolShapeLabel': 'Tvar symbolu',
	'lineColumnComboChartProp_hideSymbolsLabel': 'Skrýt symboly',
	'lineColumnComboChartProp_hideSymbolsDescription': 'Skrýt symboly',
	'lineColumnComboChartProp_hideDataLinesLabel': 'Skrýt čáry',
	'lineColumnComboChartProp_hideDataLinesDescription': 'Skrýt čáry',
	'lineColumnComboChartProp_interpolationLabel': 'Plynulý čárový',
	'lineColumnComboChartProp_interpolationDescription': 'Čáry spojující datové body jsou zakřivené.',
	'lineColumnComboChartProp_hideGridLinesLabel': 'Skrýt čáry mřížky',
	'lineColumnComboChartProp_hideGridLinesDescription': 'Skrýt čáry mřížky',
	'lineColumnComboChartProp_hideAxisTitleLabelsLabel': 'Skrýt popisky s nadpisy os',
	'lineColumnComboChartProp_hideAxisTitleLabelsDescription': 'Skrýt nadpisy pro osy.',
	'lineColumnComboChartProp_maintainAxisScalesLabel': 'Zachovat měřítka osy',
	'lineColumnComboChartProp_maintainAxisScalesDescription': 'Vždy na osách zobrazovat minimální a maximální hodnoty.',
	'lineColumnComboChartProp_suppressZerosLabel': 'Skrýt prázdné',
	'lineColumnComboChartProp_suppressZerosDescription': 'Skrýt kategorie bez přidružených hodnot.',
	'lineColumnComboChartProp_hideLegendLabel': 'Skrýt legendu',
	'lineColumnComboChartProp_hideLegendDescription': 'Skrýt legendu.',
	'lineColumnComboChartProp_legendPositionLabel': 'Poloha legendy',
	'summaryCaption': 'Souhrn',
	'areaName': 'Plošný',
	'areaDescription': 'Plošný',
	'areaDataSlot_colorLabel': 'Barva podle:',
	'areaDataSlot_valuesLabel': 'Hodnota',
	'areaDataSlot_categoriesLabel': 'Popisek osy',
	'bubbleName': 'Bublinový',
	'bubbleDescription': 'Bublinový',
	'bubbleDataSlot_yAxisLabel': 'Svislá osa',
	'bubbleDataSlot_xAxisLabel': 'Vodorovná osa',
	'bubbleDataSlot_sizeLabel': 'Velikost podle:',
	'bubbleDataSlot_colorLabel': 'Barva podle:',
	'clusterBarName': 'Pruhový',
	'clusterBarDescription': 'Pruhový',
	'clusterBarDataSlot_colorLabel': 'Barva podle:',
	'clusterBarDataSlot_valuesLabel': 'Hodnota',
	'clusterBarDataSlot_categoriesLabel': 'Popisek osy',
	'clusterBarDataSlot_valuesRepeatingLabel': 'Hodnota',
	'clusterColumnName': 'Sloupec',
	'clusterColumnDescription': 'Sloupec',
	'clusterColumnDataSlot_colorLabel': 'Barva podle:',
	'clusterColumnDataSlot_valuesLabel': 'Hodnota',
	'clusterColumnDataSlot_categoriesLabel': 'Popisek osy',
	'clusterColumnDataSlot_valuesRepeatingLabel': 'Hodnota',
	'clusterLineName': 'Čára',
	'clusterLineDescription': 'Čára',
	'clusterLineDataSlot_colorLabel': 'Barva podle:',
	'clusterLineDataSlot_valuesLabel': 'Svislá osa',
	'clusterLineDataSlot_categoriesLabel': 'Vodorovná osa',
	'clusterLineDataSlot_valuesRepeatingLabel': 'Hodnota',
	'gridName': 'Mřížka',
	'gridDescription': 'Mřížka',
	'gridDataSlot_grid_colsLabel': 'Sloupec',
	'heatName': 'Teplotní',
	'heatDescription': 'Teplotní',
	'heatDataSlot_yAxisLabel': 'Svislá osa',
	'heatDataSlot_xAxisLabel': 'Vodorovná osa',
	'heatDataSlot_valuesLabel': 'Teplota podle:',
	'lineColumnComboName': 'Čára a sloupec',
	'lineColumnComboDescription': 'Čára a sloupec',
	'lineColumnComboDataSlot_lineValueLabel': 'Čárová hodnota',
	'lineColumnComboDataSlot_categoryLabel': 'Popisek osy',
	'lineColumnComboDataSlot_columnValueLabel': 'Sloupcová hodnota',
	'mapName': 'Starší mapa',
	'mapDescription': 'Starší mapa',
	'mapDataSlot_sizeLabel': 'Velikost bodu',
	'mapDataSlot_valuesLabel': 'Teplota oblasti',
	'mapDataSlot_sizeHeatLabel': 'Teplota bodu',
	'mapDataSlot_categoriesLabel': 'Oblasti',
	'packedBubbleName': 'Sbalený bublinový',
	'packedBubbleDescription': 'Sbalený bublinový',
	'packedBubbleDataSlot_sizeLabel': 'Velikost podle:',
	'packedBubbleDataSlot_colorLabel': 'Barva podle:',
	'packedBubbleDataSlot_categoriesLabel': 'Kategorie',
	'pieName': 'Výsečový',
	'pieDescription': 'Výsečový',
	'pieDataSlot_valuesLabel': 'Hodnota',
	'pieDataSlot_categoriesLabel': 'Kategorie',
	'playerName': 'Přehrávač dat',
	'playerDescription': 'Přehrávač dat',
	'playerDataSlot_categoriesLabel': 'Popisek osy',
	'pointName': 'Bod',
	'pointDescription': 'Bod',
	'pointDataSlot_colorLabel': 'Barva podle:',
	'pointDataSlot_valuesLabel': 'Hodnota',
	'pointDataSlot_categoriesLabel': 'Popisek osy',
	'radialName': 'Radiální',
	'radialDescription': 'Radiální',
	'radialDataSlot_valuesLabel': 'Hodnota',
	'radialDataSlot_maxSizeLabel': 'Maximální hodnota',
	'radialDataSlot_categoriesLabel': 'Kategorie',
	'radialBarName': 'Radiální pruhový',
	'radialBarDescription': 'Radiální pruhový',
	'radialBarDataSlot_valuesLabel': 'Hodnota',
	'radialBarDataSlot_categoriesLabel': 'Kategorie',
	'scatterPlotName': 'Bodový výkres',
	'scatterPlotDescription': 'Bodový výkres',
	'scatterPlotDataSlot_yAxisLabel': 'Svislá osa',
	'scatterPlotDataSlot_xAxisLabel': 'Vodorovná osa',
	'scatterPlotDataSlot_colorLabel': 'Barva podle:',
	'scatterPlotDataSlot_categoriesLabel': 'Body',
	'stackedBarName': 'Skládaný pruhový',
	'stackedBarDescription': 'Skládaný pruhový',
	'stackedBarDataSlot_colorLabel': 'Barva podle:',
	'stackedBarDataSlot_valuesLabel': 'Hodnota',
	'stackedBarDataSlot_categoriesLabel': 'Popisek osy',
	'stackedBarDataSlot_valuesRepeatingLabel': 'Hodnota',
	'stackedColumnName': 'Skládaný sloupcový',
	'stackedColumnDescription': 'Skládaný sloupcový',
	'stackedColumnDataSlot_colorLabel': 'Barva podle:',
	'stackedColumnDataSlot_valuesLabel': 'Hodnota',
	'stackedColumnDataSlot_categoriesLabel': 'Popisek osy',
	'stackedColumnDataSlot_valuesRepeatingLabel': 'Hodnota',
	'summaryChartName': 'Souhrn',
	'summaryChartDescription': 'Souhrn',
	'summaryChartDataSlot_valuesLabel': 'Hodnota',
	'treeMapName': 'Stromová mapa',
	'treeMapDescription': 'Stromová mapa',
	'treeMapDataSlot_colorLabel': 'Teplota podle:',
	'treeMapDataSlot_valuesLabel': 'Velikost podle:',
	'treeMapDataSlot_categoriesLabel': 'Úroveň 1',
	'treeMapDataSlot_level3Label': 'Úroveň 3',
	'treeMapDataSlot_level2Label': 'Úroveň 2',
	'wordCloudName': 'Shluk slov',
	'wordCloudDescription': 'Shluk slov',
	'wordCloudDataSlot_colorLabel': 'Barva podle:',
	'wordCloudDataSlot_scaleLabel': 'Velikost podle:',
	'wordCloudDataSlot_wordLabel': 'Slova',
	'treeMap1Cat1MeasureChartCaption': 'Stromová mapa',
	'treeMap1Cat1MeasureChartDataSlot_categoriesLabel': 'Úroveň 1',
	'treeMap1Cat1MeasureChartDataSlot_valuesLabel': 'Velikost podle:',
	'treeMap1Cat1MeasureChartProp_colorPaletteLabel': 'Palety barev',
	'treeMap1Cat2MeasureChartProp_colorPaletteLabel': 'Palety barev',
	'treeMap2Cat1MeasureChartProp_colorPaletteLabel': 'Palety barev',
	'treeMap2Cat2MeasureChartProp_colorPaletteLabel': 'Palety barev',
	'treeMap3Cat1MeasureChartProp_colorPaletteLabel': 'Palety barev',
	'treeMap3Cat2MeasureChartProp_colorPaletteLabel': 'Palety barev',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesLabel': 'Zachovat měřítka osy',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesDescription': 'Vždy na osách zobrazovat minimální a maximální hodnoty.',
	'treeMap1Cat1MeasureChartProp_suppressZerosLabel': 'Skrýt prázdné',
	'treeMap1Cat1MeasureChartProp_suppressZerosDescription': 'Skrýt kategorie bez přidružených hodnot.',
	'treeMap1Cat1MeasureChartProp_hideLegendLabel': 'Skrýt legendu',
	'treeMap1Cat1MeasureChartProp_hideLegendDescription': 'Skrýt legendu.',
	'treeMap1Cat1MeasureChartProp_legendPositionLabel': 'Poloha legendy',
	'wordChart1Cat1MeasureCaption': 'Shluk slov',
	'wordChart1Cat1MeasureDataSlot_wordLabel': 'Slova',
	'wordChart1Cat1MeasureDataSlot_scaleLabel': 'Velikost podle:',
	'wordChart1Cat1MeasureProp_colorPaletteLabel': 'Palety barev',
	'wordChart1Cat1MeasureProp_elementColorLabel': 'Barva slova',
	'wordChart1Cat1MeasureProp_maintainAxisScalesLabel': 'Zachovat měřítka osy',
	'wordChart1Cat1MeasureProp_maintainAxisScalesDescription': 'Vždy na osách zobrazovat minimální a maximální hodnoty.',
	'wordChart1Cat1MeasureProp_suppressZerosLabel': 'Skrýt prázdné',
	'wordChart1Cat1MeasureProp_suppressZerosDescription': 'Skrýt kategorie bez přidružených hodnot.',
	'missingDataSetData': 'Data pro tuto datovou sadu nejsou k dispozici. Aktualizujte datovou sadu nebo požádejte administrátora o přístup ke zdroji.',
	'hideShowSummaries': 'Skrýt/zobrazit souhrny',
	'crosstabName': 'Kontingenční tabulka',
	'value_is_not_available': 'Není k dispozici',
	'swapRowsAndColumns': 'Prohodit řádky a sloupce',
	'NoPinsCollected': 'Žádné fixované vizualizace',
	'pinSearchOld': 'Prohledávat moje fixace',
	'pinDeletedToast': 'Fixace byla zrušena.',
	'pinAddedToast': 'Fixace byla úspěšně přidána do seznamu Moje fixace.',
	'pinRetrieveError': 'Nelze načíst jeden nebo více fixací. Opakujte operaci později.',
	'pinErrorTitle': 'Chyba fixace',
	'renamePinTooltip': 'Zadat název...',
	'renamePinInvalidText': 'Toto pole je povinné.',
	'pinRemove': 'Odebrat',
	'deletePin': 'Odstranit fixaci',
	'renamePin': 'Přejmenovat',
	'cancelRenamePin': 'Storno',
	'confirmRenamePin': 'Hotovo',
	'dataset_time': 'čas',
	'dataset_date': 'datum',
	'dataset_location': 'umístění',
	'dataset_number': 'číslo',
	'dataset_text': 'text',
	'widgetConditionalFormatLabel': 'Přepnout ovládací prvky podmíněného formátování',
	'deletePinConfirmationMessage': 'Opravdu chcete tuto fixaci odstranit? Tuto operaci nelze vrátit zpět.',
	'deletePinConfirm': 'Potvrdit odstranění',
	'pinDeleteError': 'Nelze odstranit jeden nebo více fixací. Opakujte operaci později.',
	'metadataPickerTitle': 'Vytvořit datovou sadu',
	'moreTitle': 'Další',
	'remove_slider_handle': 'Odebrat úchyt',
	'missingFiltering': 'Chybějící sloupec:',
	'unSupportedPromptType': 'Scénář s výzvou není aktuálně podporován.',
	'preAggregateLabel': 'Použít hodnoty výzvy k zadání ze zdroje dat',
	'postAggregateLabel': 'Použít hodnoty výzvy k zadání v sestavě',
	'preAggregateText': 'Rozsah používá hodnoty ve zdroji dat, nikoli hodnoty zobrazené na panelu dashboard.',
	'tabName_general': 'Obecné', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visDetails': 'Podrobnosti',
	'tabName_textDetails': 'Podrobnosti textu', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_mediaDetails': 'Podrobnosti médií', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_webDetails': 'Podrobnosti webové stránky', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_imageDetails': 'Podrobnosti obrazu', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visualization': 'Vizualizace',
	'sectionName_canvas': 'Plátno',
	'sectionName_colorsAndThemes_v1': 'Barva a motiv',
	'sectionName_colorsAndThemes': 'Motiv a pozadí',
	'colorsAndThemes_legacyWarning': 'Aktuální panel dashboard používá motiv z dřívější verze. Změnou motivu a uložením panelu dashboard trvale ztratíte přístup k paletám dřívějších motivů.',
	'sectionName_details': 'Podrobnosti',
	'sectionName_positionAndStyle': 'Poloha a styl',
	'sectionName_appearance': 'Vzhled', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_advanced': 'Rozšířené',
	'sectionName_layout': 'Rozvržení', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_tabs': 'Popisky karet',
	'sectionName_tabTitle': 'Popisek',
	'sectionName_tabBackground': 'Pozadí',
	'addDataSourceDialogTitle': 'Přidat zdroj dat',
	'addDataSourceDialogButtonLabel': 'Přidat',
	'shapesDoubleChevron': 'Dvojité mřížkování',
	'widgetsPanelTitle': 'Moduly widget',
	'widgetsPanelBasicsTab': 'Základy',
	'widgetsPanelImageLibraryTab': 'Obrázky',
	'widgetsPanelSectionStandard': 'Standardní',
	'widgetsPanelSectionAdvanced': 'Rozšířené',
	'widgetsPanelSectionShapes': 'Tvary',
	'customWidgetsTitle': 'Vlastní moduly widget',
	'filterItemCanvasMove': 'Přidat na plátno',
	'filterOverflowMenu_Global': 'Nabídka přetečení všech karet',
	'filterOverflowMenu_Tab': 'Nabídka přetečení této karty',
	'filterOverflowMenu_Item': 'Nabídka přetečení filtru',
	'filterOverflowMenu_Single': 'Nabídka přetečení',
	'filterItemEdit': 'Upravit hodnoty filtru',
	'filterDeleteAllItems': 'Odstranit všechny filtry',
	'filterClearAllItems': 'Vymazat všechny filtry',
	'filterClearSelection': 'Vymazat filtr',
	'filterPlayerMode': 'Zobrazit přehrávač',
	'filterStaticMode': 'Zobrazit seznam',
	'filterInvertSelection': 'Invertovat filtr',
	'filterIconLabel_Global': 'Všechny karty',
	'filterIconLabel_Single': 'Filtry',
	'filterIconLabel_Tab': 'Tato karta',
	'filterIconTooltip_Global': 'Všechny karty',
	'filterIconTooltip_Tab': 'Tato karta',
	'filterIconTooltip_Single': 'Filtry',
	'filterItemDelete': 'Odstranit filtr',
	'filterValueSeparator': ',',
	'filterRange': '%{from}-%{to}',
	'filterInvertRange': 'všechno kromě: %{from}-%{to}',
	'filterExcept': 'kromě %{values}',
	'filterAll': 'Vše',
	'filterBlank': '(prázdné)',
	'filterDisableRangeInvert': 'Není k dispozici, pokud je tento sloupec obsažen ve filtru Všechny karty.',
	'filterDisableHierarchyInvert': 'Není k dispozici, pokud je tento sloupec obsažen ve filtru hierarchie.',
	'filterSelectedOfTotal': '%{selected} z %{totalMembers}',
	'filter_date_before': 'Před %{to}',
	'filter_date_before_except': 'Ne před %{to}',
	'filter_date_after': 'Po %{from}',
	'filter_date_after_except': 'Ne po %{from}',
	'filter_date_between': 'Mezi %{from} a %{to}',
	'filter_date_between_except': 'Ne mezi %{from} a %{to}',
	'filter_drag_and_drop_all_tabs': 'Přetáhněte data sem, aby se filtrovaly všechny karty.',
	'filter_drag_and_drop_current_tab': 'Přetáhněte data sem, aby se filtrovala tato karta.',
	'filter_drag_and_drop_single_dock': 'Přetáhněte data sem, aby se filtrovala.',
	'errMsgFilterItemGenericTitle': 'Nelze načíst hodnoty filtru',
	'widgetChromeRotate': 'Otočit',
	'toolbarRegionLabel': 'Panel nástrojů',
	'toolbarActionDelete': 'Odstranit',
	'toolbarActionGroup': 'Skupina',
	'toolbarActionUngroup': 'Zrušit seskupení',
	'toolbarActionOrderToFront': 'Odeslat do popředí',
	'toolbarActionOrderToBack': 'Odeslat do pozadí',
	'toolbarActionEditTitle': 'Upravit nadpis',
	'toolbarActionWrapTitle': 'Zalomit nadpis',
	'toolbarActionPin': 'Shromáždit',
	'toolbarActionPinOld': 'Fixovat',
	'toolbarActionAlign': 'Zarovnat',
	'alignWidgetLeft': 'Vlevo',
	'alignWidgetCenter': 'Na střed',
	'alignWidgetRight': 'Vpravo',
	'alignWidgetTop': 'Nahoře',
	'alignWidgetMiddle': 'Střed',
	'alignWidgetBottom': 'Dole',
	'distributeWidgetsVertical': 'Rozdělit svisle',
	'distributeWidgetsHoriz': 'Rozdělit vodorovně',
	'toolbarChangeVisualization': 'Změnit vizualizaci',
	'multipurposeHeader': 'Vybrat typ modulu widget',
	'multipurposePlaceholderText': 'Vyberte jeden z modulů widget, abyste mohli začít.',
	'live_label': 'Graf',
	'filter_label': 'Filtr',
	'one_named_live': 'Graf %{name}',
	'one_named_live_numbered': 'Graf %{name} (%{number})',
	'one_unknown_live': 'Graf',
	'one_unknown_live_numbered': 'Graf (%{number})',
	'few_live': 'Skupina grafů %{count}',
	'many_live': 'Skupina grafů %{count}',
	'one_custom': 'Vlastní modul widget',
	'one_custom_named': '%{name}',
	'one_custom_named_numbered': '%{name} (%{number})',
	'one_named_filter': 'Filtr %{name}',
	'one_named_filter_numbered': 'Filtr %{name} (%{number})',
	'one_unknown_filter': 'Filtr',
	'one_unknown_filter_numbered': 'Filtr (%{number})',
	'few_filter': 'Skupina filtrů %{count}',
	'many_filter': 'Skupina filtrů %{count}',
	'LIVE_bar_has_mapping': 'Pruhový graf %{values}',
	'LIVE_bar_has_mapping_numbered': 'Pruhový graf %{values} (%{number})',
	'LIVE_bar_opt_mapping': 'Pruhový graf %{categories} podle %{values}',
	'LIVE_bar_opt_mapping_numbered': 'Pruhový graf %{categories} podle %{values} (%{number})',
	'LIVE_bar_no_mapping': 'Prázdný pruhový graf',
	'LIVE_bar_no_mapping_numbered': 'Prázdný pruhový graf (%{number})',
	'LIVE_bar_named': 'Pruhový graf %{name}',
	'LIVE_bar_named_numbered': 'Pruhový graf %{name} (%{number})',
	'LIVE_stacked_bar_has_mapping': 'Skládaný pruhový graf %{values}',
	'LIVE_stacked_bar_has_mapping_numbered': 'Skládaný pruhový graf %{values} (%{number})',
	'LIVE_stacked_bar_opt_mapping': 'Skládaný pruhový graf %{categories} podle %{values}',
	'LIVE_stacked_bar_opt_mapping_numbered': 'Skládaný pruhový graf %{categories} podle %{values} (%{number})',
	'LIVE_stacked_bar_no_mapping': 'Prázdný skládaný pruhový graf',
	'LIVE_stacked_bar_no_mapping_numbered': 'Prázdný skládaný pruhový graf (%{number})',
	'LIVE_stacked_bar_named': 'Skládaný pruhový graf %{name}',
	'LIVE_stacked_bar_named_numbered': 'Skládaný pruhový graf %{name} (%{number})',
	'LIVE_bubble_has_mapping': 'Bublinový graf: %{categories} podle %{x} a %{y}',
	'LIVE_bubble_has_mapping_numbered': 'Bublinový graf: %{categories} podle %{x} a %{y} (%{number})',
	'LIVE_bubble_no_mapping': 'Prázdný bublinový graf',
	'LIVE_bubble_no_mapping_numbered': 'Prázdný bublinový graf (%{number})',
	'LIVE_bubble_named': 'Bublinový graf %{name}',
	'LIVE_bubble_named_numbered': 'Bublinový graf %{name} (%{number})',
	'LIVE_composite_has_mapping': 'Kompozitní graf %{categories} podle %{columnValue} a %{lineValue}',
	'LIVE_composite_has_mapping_numbered': 'Kompozitní graf %{categories} podle %{columnValue} a %{lineValue} (%{number})',
	'LIVE_composite_no_mapping': 'Prázdný kompozitní graf',
	'LIVE_composite_no_mapping_numbered': 'Prázdný kompozitní graf (%{number})',
	'LIVE_composite_named': 'Kompozitní graf %{name}',
	'LIVE_composite_named_numbered': 'Kompozitní graf %{name} (%{number})',
	'LIVE_decision_tree_has_mapping': 'Rozhodovací strom %{values}',
	'LIVE_decision_tree_has_mapping_numbered': 'Rozhodovací strom %{values} (%{number})',
	'LIVE_decision_tree_no_mapping': 'Prázdný rozhodovací strom',
	'LIVE_decision_tree_no_mapping_numbered': 'Prázdný rozhodovací strom (%{number})',
	'LIVE_decision_tree_named': 'Rozhodovací strom %{name}',
	'LIVE_decision_tree_named_numbered': 'Rozhodovací strom %{name} (%{number})',
	'LIVE_packed_bubble_has_mapping': 'Sbalený bublinový graf %{categories}',
	'LIVE_packed_bubble_has_mapping_numbered': 'Sbalený bublinový graf %{categories} (%{number})',
	'LIVE_packed_bubble_no_mapping': 'Prázdný sbalený bublinový graf',
	'LIVE_packed_bubble_no_mapping_numbered': 'Prázdný sbalený bublinový graf (%{number})',
	'LIVE_packed_bubble_named': 'Sbalený bublinový graf %{name}',
	'LIVE_packed_bubble_named_numbered': 'Sbalený bublinový graf %{name} (%{number})',
	'LIVE_pie_has_mapping': 'Výsečový graf %{categories} podle %{values}',
	'LIVE_pie_has_mapping_numbered': 'Výsečový graf %{categories} podle %{values} (%{number})',
	'LIVE_pie_no_mapping': 'Prázdný výsečový graf',
	'LIVE_pie_no_mapping_numbered': 'Prázdný výsečový graf (%{number})',
	'LIVE_pie_named': 'Výsečový graf %{name}',
	'LIVE_pie_named_numbered': 'Výsečový graf %{name} (%{number})',
	'LIVE_pie_as_donut_has_mapping': 'Prstencový graf %{categories} podle %{values}',
	'LIVE_pie_as_donut_has_mapping_numbered': 'Prstencový graf %{categories} podle %{values} (%{number})',
	'LIVE_pie_as_donut_no_mapping': 'Prázdný prstencový graf',
	'LIVE_pie_as_donut_no_mapping_numbered': 'Prázdný prstencový graf (%{number})',
	'LIVE_pie_as_donut_named': 'Prstencový graf %{name}',
	'LIVE_pie_as_donut_named_numbered': 'Prstencový graf %{name} (%{number})',
	'LIVE_line_has_mapping': 'Prstencový graf %{categories} podle %{values}',
	'LIVE_line_has_mapping_numbered': 'Čárový graf %{categories} podle %{values} (%{number})',
	'LIVE_line_no_mapping': 'Prázdný čárový graf',
	'LIVE_line_no_mapping_numbered': 'Prázdný čárový graf (%{number})',
	'LIVE_line_named': 'Čárový graf %{name}',
	'LIVE_line_named_numbered': 'Čárový graf %{name} (%{number})',
	'LIVE_area_has_mapping': 'Plošný graf %{categories} podle %{values}',
	'LIVE_area_has_mapping_numbered': 'Plošný graf %{categories} podle %{values} (%{number})',
	'LIVE_area_no_mapping': 'Prázdný plošný graf',
	'LIVE_area_no_mapping_numbered': 'Prázdný plošný graf (%{number})',
	'LIVE_area_named': 'Plošný graf %{name}',
	'LIVE_area_named_numbered': 'Plošný graf %{name} (%{number})',
	'LIVE_area_as_stacked_percent_has_mapping': 'Skládaný procentní plošný graf %{categories} podle %{values}',
	'LIVE_area_as_stacked_percent_has_mapping_numbered': 'Skládaný procentní plošný graf %{categories} podle %{values} (%{number})',
	'LIVE_area_as_stacked_percent_no_mapping': 'Prázdný skládaný procentní plošný graf',
	'LIVE_area_as_stacked_percent_no_mapping_numbered': 'Prázdný skládaný procentní plošný graf (%{number})',
	'LIVE_area_as_stacked_percent_named': 'Skládaný procentní plošný graf %{name}',
	'LIVE_area_as_stacked_percent_named_numbered': 'Skládaný procentní plošný graf %{name} (%{number})',
	'LIVE_heatmap_has_mapping': 'Teplotní mapa %{color}',
	'LIVE_heatmap_has_mapping_numbered': 'Teplotní mapa %{color} (%{number})',
	'LIVE_heatmap_no_mapping': 'Prázdná teplotní mapa',
	'LIVE_heatmap_no_mapping_numbered': 'Prázdná teplotní mapa (%{number})',
	'LIVE_heatmap_named': 'Teplotní mapa %{name}',
	'LIVE_heatmap_named_numbered': 'Teplotní mapa %{name} (%{number})',
	'LIVE_network_opt_mapping': 'Síť %{categories} podle %{series} a %{values}',
	'LIVE_network_opt_mapping_numbered': 'Síť %{categories} podle %{series} a %{values} (%{number})',
	'LIVE_network_has_mapping': 'Síť %{categories} podle %{series}',
	'LIVE_network_has_mapping_numbered': 'Síť %{categories} podle %{series} (%{number})',
	'LIVE_network_no_mapping': 'Prázdná síť',
	'LIVE_network_no_mapping_numbered': 'Prázdná síť (%{number})',
	'LIVE_network_named': 'Síť %{name}',
	'LIVE_network_named_numbered': 'Síť %{name} (%{number})',
	'LIVE_radial_bar_opt_mapping': 'Radiální pruhový graf %{categories} podle %{values}',
	'LIVE_radial_bar_opt_mapping_numbered': 'Radiální pruhový graf %{categories} podle %{values} (%{number})',
	'LIVE_radial_bar_has_mapping': 'Radiální pruhový graf %{values}',
	'LIVE_radial_bar_has_mapping_numbered': 'Radiální pruhový graf %{values} (%{number})',
	'LIVE_radial_bar_no_mapping': 'Prázdný radiální pruhový graf',
	'LIVE_radial_bar_no_mapping_numbered': 'Prázdný radiální pruhový graf (%{number})',
	'LIVE_radial_bar_named': 'Radiální pruhový graf %{name}',
	'LIVE_radial_bar_named_numbered': 'Radiální pruhový graf %{name} (%{number})',
	'LIVE_spiral_has_mapping': 'Spirálový graf %{values}',
	'LIVE_spiral_has_mapping_numbered': 'Spirálový graf %{values} (%{number})',
	'LIVE_spiral_no_mapping': 'Prázdný spirálový graf',
	'LIVE_spiral_no_mapping_numbered': 'Prázdný spirálový graf (%{number})',
	'LIVE_spiral_named': 'Spirálový graf %{name}',
	'LIVE_spiral_named_numbered': 'Spirálový graf %{name} (%{number})',
	'LIVE_treemap_has_mapping': 'Stromová mapa %{categories} podle %{size}',
	'LIVE_treemap_has_mapping_numbered': 'Stromová mapa %{categories} podle %{size} (%{number})',
	'LIVE_treemap_no_mapping': 'Prázdná stromová mapa',
	'LIVE_treemap_no_mapping_numbered': 'Prázdná stromová mapa (%{number})',
	'LIVE_treemap_named': 'Stromová mapa %{name}',
	'LIVE_treemap_named_numbered': 'Stromová mapa %{name} (%{number})',
	'LIVE_wordcloud_has_mapping': 'Shluk slov %{categories}',
	'LIVE_wordcloud_has_mapping_numbered': 'Shluk slov %{categories} (%{number})',
	'LIVE_wordcloud_no_mapping': 'Prázdný shluk slov',
	'LIVE_wordcloud_no_mapping_numbered': 'Prázdný shluk slov (%{number})',
	'LIVE_wordcloud_named': 'Shluk slov %{name}',
	'LIVE_wordcloud_named_numbered': 'Shluk slov %{name} (%{number})',
	'LIVE_data_player_has_mapping': 'Přehrávač dat %{category}',
	'LIVE_data_player_has_mapping_numbered': 'Přehrávač dat %{category} (%{number})',
	'LIVE_data_player_no_mapping': 'Prázdný přehrávač dat',
	'LIVE_data_player_no_mapping_numbered': 'Prázdný přehrávač dat (%{number})',
	'LIVE_data_player_named': 'Přehrávač dat %{name}',
	'LIVE_data_player_named_numbered': 'Přehrávač dat %{name} (%{number})',
	'LIVE_map_has_mapping': 'Mapa %{locations}',
	'LIVE_map_has_mapping_numbered': 'Mapa %{locations} (%{number})',
	'LIVE_map_no_mapping': 'Prázdná mapa',
	'LIVE_map_no_mapping_numbered': 'Prázdná mapa (%{number})',
	'LIVE_map_named': 'Mapa %{name}',
	'LIVE_map_named_numbered': 'Mapa %{name} (%{number})',
	'LIVE_point_has_mapping': 'Bodový graf %{categories} podle %{values}',
	'LIVE_point_has_mapping_numbered': 'Bodový graf %{categories} podle %{values} (%{number})',
	'LIVE_point_no_mapping': 'Prázdný bodový graf',
	'LIVE_point_no_mapping_numbered': 'Prázdný bodový graf (%{number})',
	'LIVE_point_named': 'Bodový graf %{name}',
	'LIVE_point_named_numbered': 'Bodový graf %{name} (%{number})',
	'LIVE_column_has_mapping': 'Sloupcový graf %{values}',
	'LIVE_column_has_mapping_numbered': 'Sloupcový graf %{values} (%{number})',
	'LIVE_column_opt_mapping': 'Sloupcový graf %{categories} podle %{values}',
	'LIVE_column_opt_mapping_numbered': 'Sloupcový graf %{categories} podle %{values} (%{number})',
	'LIVE_column_no_mapping': 'Prázdný sloupcový graf',
	'LIVE_column_no_mapping_numbered': 'Prázdný sloupcový graf (%{number})',
	'LIVE_column_named': 'Sloupcový graf %{name}',
	'LIVE_column_named_numbered': 'Sloupcový graf %{name} (%{number})',
	'LIVE_stacked_column_has_mapping': 'Skládaný sloupcový graf %{values}',
	'LIVE_stacked_column_has_mapping_numbered': 'Skládaný sloupcový graf %{values} (%{number})',
	'LIVE_stacked_column_opt_mapping': 'Skládaný sloupcový graf %{categories} podle %{values}',
	'LIVE_stacked_column_opt_mapping_numbered': 'Skládaný sloupcový graf %{categories} podle %{values} (%{number})',
	'LIVE_stacked_column_no_mapping': 'Prázdný skládaný sloupcový graf',
	'LIVE_stacked_column_no_mapping_numbered': 'Prázdný skládaný sloupcový graf (%{number})',
	'LIVE_stacked_column_named': 'Skládaný sloupcový graf %{name}',
	'LIVE_stacked_column_named_numbered': 'Skládaný sloupcový graf %{name} (%{number})',
	'LIVE_scatter_opt_mapping': 'Bodový výkres %{categories} podle %{x} a %{y}',
	'LIVE_scatter_opt_mapping_numbered': 'Bodový výkres %{categories} podle %{x} a %{y} (%{number})',
	'LIVE_scatter_has_mapping': 'Bodový výkres %{x} vs. %{y}',
	'LIVE_scatter_has_mapping_numbered': 'Bodový výkres %{x} vs. %{y} (%{number})',
	'LIVE_scatter_no_mapping': 'Prázdný bodový výkres',
	'LIVE_scatter_no_mapping_numbered': 'Prázdný bodový výkres (%{number})',
	'LIVE_scatter_named': 'Bodový výkres %{name}',
	'LIVE_scatter_named_numbered': 'Bodový výkres %{name} (%{number})',
	'LIVE_waterfall_has_mapping': 'Kaskádový graf %{values}',
	'LIVE_waterfall_has_mapping_numbered': 'Kaskádový graf %{values} (%{number})',
	'LIVE_waterfall_no_mapping': 'Prázdný kaskádový graf',
	'LIVE_waterfall_no_mapping_numbered': 'Prázdný kaskádový graf (%{number})',
	'LIVE_waterfall_named': 'Kaskádový graf %{name}',
	'LIVE_waterfall_named_numbered': 'Kaskádový graf %{name} (%{number})',
	'LIVE_empty_visualization_hint_title': 'Sestavit vlastní vizualizaci',
	'LIVE_empty_visualization_hint_description': 'Přetáhněte sloupce sem nebo do pozic vlevo.',
	'LIVE_slots_required_field_description': '%{asterisk} Označuje povinné pole',
	'LIVE_slots_drag_and_drop_description': 'Přetáhněte data do pozic nahoře, aby se sestavila a filtrovala vizualizace.',
	'requiredField': 'Povinné pole',
	'fullScreenEnter': 'Vstoupit do režimu celé obrazovky',
	'fullScreenClose': 'Ukončit režim celé obrazovky',
	'noExtraText_multipurpose': 'Víceúčelový zástupný symbol',
	'noExtraText_multipurpose_numbered': 'Víceúčelový zástupný symbol (%{number})',
	'one_placeholder_vis': 'Zástupný symbol vizualizace',
	'one_placeholder_vis_numbered': 'Zástupný symbol vizualizace (%{number})',
	'one_placeholder_text': 'Zástupný znak textu',
	'one_placeholder_text_numbered': 'Zástupný znak textu (%{number})',
	'few_placeholder_text': 'Skupina zástupných symbolů textu %{count}',
	'many_placeholder_text': 'Skupina zástupných symbolů textu %{count}',
	'filter_includesAll': 'Zahrnuje vše',
	'timeline_filter_moved_to': 'Filtr časové osy %{id} byl přesunut na %{time}',
	'timelineSettingsButton': 'Volby přehrávání',
	'autoPlay': 'Přehrát všechny scény',
	'loop': 'Přehrávat ve smyčce',
	'noSceneTransitionLabel': 'Žádný',
	'sceneTransitionPropertyLabel': 'Přechod scény',
	'animatedPathSceneTransitionLabel': 'Animovaná cesta',
	'sweepSceneTransitionLabel': 'Pohyb',
	'propAniAnimation': 'Animace',
	'propAniTypeEntrance': 'Vstupní animace',
	'propAniDirectionIn': 'Vstupní směr',
	'propAniTypeExit': 'Výstupní animace',
	'propAniDirectionOut': 'Výstupní směr',
	'propAniDirection': 'Směr',
	'timelineAnimationProperties': 'Otevřít vlastnosti animace',
	'editStoryCoachMarkTitle': 'Upravit scénář',
	'editStoryCoachMarkContents': 'Chcete-li tento scénář upravit, klepněte na ikonu tužky.',
	'addDataStoryCoachMarkContents': 'Pomocí myši přetáhněte data z panelu dat do scénáře.',
	'expandSceneCoachmarkTitle': 'Otevřít časovou osu',
	'expandSceneCoachmarkContents': 'Scénu lze animovat provedení úpravy viditelnosti objektů podle času a doby trvání.',
	'overviewCoachmarkTitle': 'Přehledové scény',
	'overviewCoachmarkContents': 'Prostřednictvím přehledových scén na začátku a konci scénáře lze zobrazit celkový kontext všech scén. Z přehledové scény lze přetažením vyměnit scénu s jinou. Přehledové scény lze zobrazit nebo skrýt v rámci vlastností scénáře.',
	'animatedPathCoachmarkTitle': 'Animovaná cesta',
	'animatedPathCoachmarkContents': 'Chcete-li animovat objekt mezi dvěma scénami, duplikujte scénu s objektem. Poté objekt v nové scéně přesuňte, otočte nebo změňte jeho velikost.',
	'tabName_animation': 'Animace',
	'textWidgetIconPlaceholderText': 'Klepnutím přidejte text',
	'buildVisHeader': 'Vytvořte vizualizaci',
	'visIconPlaceholderText': 'Přetažením polí sestavíte vizualizaci',
	'launchNewExplore': 'Nové zkoumání',
	'addTo': 'Přidat do skupiny',
	'addToExisting': 'Přidat do existující...',
	'exploreData': 'Prozkoumat',
	'explore_remove_widget_styles': 'Uživatelské vlastnosti vizualizace, jako například nastavení barev, nebudou v prozkoumání zachovány.',
	'editNotebook': 'Upravit modul widget',
	'thumbnails_error_fetching': 'Chyba při načítání miniatur',
	'copy': 'Počet zkopírovaných aktiv: %{count}',
	'specConvertErr': 'Při vkládání nebo převodu specifikace panelu dashboard došlo k chybě.',
	'specCopyErr': 'Chyba při kopírování specifikace panelu dashboard',
	'pasteNotSupportedErr': 'Vkládání z %{name} není podporováno.',
	'reportParam': 'sestava',
	'filterWidgetCopyWarn': 'Vizualizace filtru nebyla zkopírována, protože filtry nejsou v tuto chvíli podporovány.',
	'upgradingDashboard': 'Upgradování "%{name}" pro %{version}...',
	'upgradeComplete': 'Upgrade dokončen',
	'individualTabProperties': 'Vlastnosti jednotlivých karet',
	'propMasterTabStylesLabel_v1': 'Globální styl karet',
	'propMasterTabStylesLabel': 'Styl všech karet',
	'propTabPosition': 'Poloha karet',
	'propTabTitle': 'Nadpis',
	'propTabBackgroundColor': 'Barva výplně',
	'propTabTextColor': 'Barva nadpisu',
	'propTabSelectedBarColor': 'Vybraná barva pruhu',
	'propTabRestoreDefaults': 'Obnovit výchozí nastavení',
	'propIndividualTabStylesLabel': 'Styl jednotlivých karet',
	'propIndividualTabStylesAriaLabel': 'Otevřít vlastnosti stylu jednotlivých karet',
	'propTabIconPosition': 'Poloha ikony',
	'propLeftTitle': 'Vlevo od nadpisu',
	'propRightTitle': 'Vpravo od nadpisu',
	'propTopTitle': 'Nad nadpisem',
	'propBottomTitle': 'Pod nadpisem',
	'propTabIconLabel': 'Vizuální',
	'propTabIcon': 'Ikona',
	'propTabIconColor': 'Barva ikony',
	'no_icon': 'Prázdné',
	'announcement': 'Oznámení',
	'api': 'Rozhraní API',
	'archive': 'Archiv',
	'asset': 'Aktivum',
	'attachment': 'Příloha',
	'audio': 'Zvuk',
	'bee': 'Včela',
	'blog': 'Blog',
	'bookmark': 'Záložka',
	'calendar': 'Kalendář',
	'camera': 'Fotoaparát',
	'capability': 'Schopnost',
	'catalog': 'Katalog',
	'chat_message': 'Zpráva konverzace',
	'checkout_cart': 'Nákupní košík',
	'client': 'Klient',
	'clock': 'Hodiny',
	'cloud': 'Mrak',
	'code': 'Kód',
	'data_quality': 'Kvalita dat',
	'folder': 'Složky',
	'forum': 'Fórum',
	'glasses': 'Brýle',
	'group': 'Skupina',
	'hat': 'Klobouk',
	'headphone': 'Sluchátka',
	'hills': 'Kopce',
	'home': 'Domovská stránka',
	'idea': 'Nápad',
	'image': 'Obrázek',
	'inventory': 'Inventář',
	'like': 'Jako',
	'link': 'Odkaz',
	'location': 'Umístění',
	'manage': 'Spravovat',
	'pen': 'Pero',
	'mobile_phone': 'Mobilní telefon',
	'music': 'Hudba',
	'notifications': 'Oznámení',
	'paint': 'Kreslit',
	'payment': 'Platba',
	'password_key': 'Klíč hesla',
	'people': 'Lidé',
	'person': 'Osoba',
	'phone': 'Telefon',
	'pin': 'Fixovat',
	'print': 'Tisk',
	'recording': 'Záznam',
	'repository': 'Úložiště',
	'role': 'Role',
	'search': 'Hledat',
	'properties': 'Vlastnosti',
	'speaker': 'Reproduktor',
	'star': 'Hvězda',
	'tag': 'Značka',
	'thumbs_up': 'Palec nahoru',
	'thumbs_down': 'Palec dolů',
	'tools': 'Nástroje',
	'traffic': 'Provoz',
	'trash': 'Koš',
	'twitter': 'Twitter',
	'unknown': 'Neznámý',
	'user': 'Uživatel',
	'venn_diagram': 'Vennův diagram',
	'video': 'Video',
	'view': 'Zobrazit',
	'warning': 'Varování',
	'watch': 'Sledovat',
	'watson': 'Watson',
	'wikis': 'Wikiweby',
	'workspace': 'Pracovní prostor',
	'world': 'Svět',
	'eventGroupButtonLabel': 'Zobrazit spojení pro modul widget',
	'dockToolbar': 'Ukotvit panel nástrojů',
	'undockToolbar': 'Zrušit ukotvení panelu nástrojů',
	'propShowTitle': 'Zobrazit nadpis',
	'textAutoFontSize': 'Automatický',
	'zoomFitToWidth': 'Přizpůsobit šířce',
	'zoomWholePage': 'Přizpůsobit stránce',
	'defaultZoomValue': 'Výchozí hodnota přiblížení',
	'zoomCategoryLabel': 'Přiblížení stránky (pouze absolutní rozvržení)'
});
